// import { createGlobalStyle } from 'styled-components/macro';
import './styles/_fonts.scss';
import { GlobalStyleProps } from './types/styles';
import {createGlobalStyle} from "styled-components";

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    height: 100%;
    overflow-x: hidden;
  }

  body {
    background: ${(props) => props.theme.palette.background.default};
    margin: 0;
    font-family: ${(props) => props.theme.typography.fontFamily};

    &.swal2-height-auto {
      height: 100% !important;
    }
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }

  .MuiTypography-root.MuiTypography-h1 {
    color: #344054;
    font-family: "Readex Pro";
    font-weight: 600;
    font-size: 34px;
    line-height: 42px;
    text-transform: capitalize;

    &.with-control {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }


  .MuiTypography-root.MuiTypography-h2 {
    color: #344054;
    font-family: "Readex Pro";
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
    text-transform: capitalize;

    &.with-control {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  
  .page-title-h3, .MuiTypography-root.MuiTypography-h3 {
    font-family: "Readex Pro";
    font-weight: 700;
    font-size: 30px !important;
    line-height: 38px !important;
    color: #344054;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: capitalize;

    &.with-control {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .MuiTypography-h6 {
    text-transform: capitalize;
  }

  /* Let's get this party started */
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px rgb(230, 230, 230);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #0283FA;
    -webkit-box-shadow: inset 0 0 3px rgb(153, 130, 245);
  }

  ::-webkit-scrollbar-thumb:window-inactive {
    background: #0283FA;
  }

  body {
    scrollbar-face-color: #0283FA;
    scrollbar-track-color: #e6e6e6;
  }
  .info-icon {
    width: 20px;
    margin-bottom: -8px;
    margin-left: 8px;
    cursor: pointer;
    color: red;
  }
`;

export const GlobalAuthStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    overflow-x: hidden;
  }

  body {
    background: linear-gradient(90deg, #684EE7 0%, #62D3E2 100%);;
    margin: 0;
    font-family: "Manrope Medium";
    overflow: hidden;
    height: auto;
    min-height: 100%;
  }
  
  body:has(.auth-signup-right) {
    background: linear-gradient(90deg, #684EE7 50%, #62D3E2 100%);
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }

  .MuiOutlinedInput-root { 
    &.Mui-focused fieldset {
      border-color: #0283FA!important;
    }
  }

  .MuiPaper-root {
    max-width: 520px;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
    border-radius: 8px;
    padding: 32px;
    margin-top: 40px;
    margin-bottom: 40px;

    @media (max-width: 767px) {
      width: 90%;
      min-width: unset;
    }

    .auth-title {
      font-weight: 700;
      font-size: 30px;
      line-height: 36px;
      color: #344054;
      text-align: center;
      margin-bottom: 8px;
      font-family: "Manrope Regular";
    }

    .form-row {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      color: #374151;
      display: flex;
      margin-bottom: 16px;
      flex-direction: column;

      &.active {
        cursor: pointer;
      }

      .label-block {
        font-weight: 500;
        width: 40%;
        line-height: 20px;
        font-family: "Manrope Medium";
        font-size: 14px;
        text-transform: capitalize;
        &.full-width {
          width: 100%;
        }
        @media (max-width: 767px) {
          width: 100%;
          line-height: 18px;
        }
      }

      .input-block {
        width: 70%;

        @media (max-width: 767px) {
          width: 100%;
        }
      }

      .MuiInputLabel-root {
        span {
          display: none;
        }
      }

    }

    .primary-button {
      color: white;
      background: #0283FA;
      border-color: #0283FA;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
      border-radius: 6px;
      font-family: "Manrope Medium";
      text-transform: capitalize; 
      
      &:hover, &:active {
        background: #319CFF;
        color: white;
      }
     
      &[disabled] {
        background: #D0D5DD;
        color: white;
      }

      &.outlined {
        border: 1px solid #D0D5DD;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        background: none;
        color: #344054;
        &:hover, &:active {
          background: #DCF0FF;
          color: #344054;
        }
      }
    }

    .secondary-button {
      background: #DCF0FF;
      color: #319CFF;
      margin-top: 5px;
      text-transform: capitalize;
      
      &:hover, &:active {
        background: #319CFF;
        color: white;
      }
      &[disabled] {
        background: #D0D5DD;
        color: white;
      }
      &.outlined {
        border: 1px solid #D0D5DD;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        background: none;
        color: #344054;
        &:hover, &:active {
          background: #DCF0FF;
          color: #344054;
        }
      }

      &.w-100 {
        width: 100%;
      }
    }
  }

  .brand-block {
    cursor: pointer;
    margin-top: 40px;

    .logo {
      width: auto;
      height: 28px;
    }
  }

  .first-arrow, .second-arrow {
    position: fixed;
    top: -25%;
    transform: scale(0.8);
    z-index: -1;
  }

  .first-arrow {
    left: 10%;
  }

  .second-arrow {
    right: -5%;
  }

  .third-arrow, .fourth-arrow {
    position: fixed;
    transform: scale(0.8);
    bottom: -45%;
    z-index: -1;

    @media (max-height: 700px) {
      display: none;
    }
  }

  .third-arrow {
    left: 0;
  }

  .fourth-arrow {
    right: 5%;
  }

  h2 {
    text-align: center;
  }

  .rights-reserved {
    opacity: 0.8;
  }

  /* Let's get this party started */
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 3px rgb(230, 230, 230);
    -webkit-border-radius: 10px;
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #0283FA;
    -webkit-box-shadow: inset 0 0 3px rgb(153, 130, 245);
  }

  ::-webkit-scrollbar-thumb:window-inactive {
    background: #0283FA;
  }

  body {
    scrollbar-face-color: #0283FA;
    scrollbar-track-color: #e6e6e6;
  }
`;


export default GlobalStyle;
